import MuiDialogTitle, { DialogTitleProps as MuiDialogTitleProps } from '@material-ui/core/DialogTitle';

import * as React from 'react';
import { DSTypographyProps, DSTypography } from '../Typography';

export type DSDialogTitleProps = MuiDialogTitleProps;
export function DSDialogTitle({ children, disableTypography = false, ...props }: DSDialogTitleProps): JSX.Element {
    const memoChildren = React.useMemo(
        () => (disableTypography ? children : <DSDialogTitleText>{children}</DSDialogTitleText>),
        [children, disableTypography],
    );
    return (
        <MuiDialogTitle {...props} disableTypography>
            {memoChildren}
        </MuiDialogTitle>
    );
}
DSDialogTitle.displayName = 'DSDialogTitle';

export type DSDialogTitleTextProps<C extends React.ElementType> = DSTypographyProps<C>;
export function DSDialogTitleText<C extends React.ElementType = 'h2'>({
    children,
    component,
    variant = 'h3',
    ...props
}: DSDialogTitleTextProps<C>): JSX.Element {
    return (
        <DSTypography component={component ?? 'h2'} variant={variant} {...props}>
            {children}
        </DSTypography>
    );
}
DSDialogTitleText.displayName = 'DSDialogTitleText';
